import { render } from "./AddressEntry.vue?vue&type=template&id=1ac67170"
import script from "./AddressEntry.vue?vue&type=script&lang=js"
export * from "./AddressEntry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohammadali/code/pnp-companies-website-typo3/extensions/pnpform/Resources/Private/Vue/form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__